import { IntercomDataDto, MemberDto } from "../generated/dashboard-client";
import { Intercom, show, update } from "@intercom/messenger-js-sdk";

const INTERCOM_APP_ID = "zholilul";

export const ChatService = {
  init(member: MemberDto) {
    // Intercom
    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: member.internalId?.toString() ?? member.id,
      email: member.email,
      name: member.name,
      created_at: new Date(member.createdDate!).getTime() / 1000,
      account_created: new Date(member.createdDate!).toString(),
    });
  },

  newMessage() {
    show();
  },

  async addMemberDetails(data: IntercomDataDto) {
    if (!data) return;

    // Intercom
    update({
      customer_level: data.customerLevel,
      last_print_order: data.lastPrintOrder,
      plan_name: data.planName,
      plan_term: data.planTerm,
      plan_status: data.planStatus,
      is_renewing: data.renewing,
      account_role: data.role,
      pos: data.pos,
      zipcode: data.zip,
      has_display: data.hasDisplay,
      has_locations: data.hasLocations,
    });
  },
};

